import { BasvuruFlow, type ProductConfig } from "./BasvuruFlow";
import { digits, InfoNote, SelectField, TextField } from "./shared";

// WEB3 — DASK teklif-talebi (lead-only, non-vehicle). Canonical [KAPI]: tam adres +
// UAVT adres kodu (kritik, e-Devlet'ten) + brüt m² + yapı tarzı + inşa yılı + kat.
// Tapu ada/parsel ve sıfat (malik/kiracı) [ADVISOR]. No vehicle block in the POST.

const YAPI_TARZI = [
  { value: "betonarme", label: "Betonarme" },
  { value: "celik", label: "Çelik" },
  { value: "yigma", label: "Yığma" },
  { value: "diger", label: "Diğer" },
];

const config: ProductConfig = {
  product: "dask",
  intro: {
    eyebrow: "DASK · TEKLİF TALEBİ",
    title: "DASK teklifi",
    text: "Zorunlu deprem sigortanız için konutunuzun adresi ve yapı bilgileri yeterli. Primi; m², yapı tarzı ve risk bölgesine göre yasa ile standarttır.",
  },
  headerTitle: "DASK",
  infoTitle: "Konutunuzu tanıyalım",
  infoLead: "Konutun adres ve yapı bilgilerini girin.",
  renderInfo: (ctx) => (
    <>
      <TextField
        id="adres"
        label="Tam adres"
        value={ctx.fields.adres ?? ""}
        onChange={ctx.setField("adres")}
        placeholder="Mahalle, cadde/sokak, no, daire"
        error={ctx.errors.adres}
      />
      <TextField
        id="uavt"
        label="UAVT adres kodu"
        inputMode="numeric"
        value={ctx.fields.uavt ?? ""}
        onChange={(v) => ctx.setField("uavt")(digits(v).slice(0, 10))}
        placeholder="10 haneli kod"
        error={ctx.errors.uavt}
      />
      <TextField
        id="m2"
        label="Brüt metrekare (m²)"
        inputMode="numeric"
        value={ctx.fields.m2 ?? ""}
        onChange={(v) => ctx.setField("m2")(digits(v).slice(0, 4))}
        placeholder="Örn. 120"
        error={ctx.errors.m2}
      />
      <SelectField
        id="yapiTarzi"
        label="Yapı tarzı"
        value={ctx.fields.yapiTarzi ?? ""}
        onChange={ctx.setField("yapiTarzi")}
        options={YAPI_TARZI}
        error={ctx.errors.yapiTarzi}
      />
      <TextField
        id="insaYili"
        label="İnşa (yapım) yılı"
        inputMode="numeric"
        value={ctx.fields.insaYili ?? ""}
        onChange={(v) => ctx.setField("insaYili")(digits(v).slice(0, 4))}
        placeholder="Örn. 2008"
        error={ctx.errors.insaYili}
      />
      <TextField
        id="kat"
        label="Bulunduğu kat"
        inputMode="numeric"
        value={ctx.fields.kat ?? ""}
        onChange={ctx.setField("kat")}
        placeholder="Örn. 3"
        error={ctx.errors.kat}
      />
      <InfoNote>
        UAVT adres kodunuzu e-Devlet’ten alabilirsiniz. Tapu ada/parsel ve malik/kiracı bilgisi
        gerekirse danışmanınız tamamlar.
      </InfoNote>
    </>
  ),
  validateInfo: (ctx) => {
    const e: Record<string, string> = {};
    if (!(ctx.fields.adres ?? "").trim()) e.adres = "Adres zorunlu.";
    if (digits(ctx.fields.uavt ?? "").length !== 10) e.uavt = "UAVT adres kodu 10 haneli olmalı.";
    if (!(ctx.fields.m2 ?? "").trim()) e.m2 = "Brüt m² zorunlu.";
    if (!(ctx.fields.yapiTarzi ?? "").trim()) e.yapiTarzi = "Yapı tarzı zorunlu.";
    if (!(ctx.fields.insaYili ?? "").trim()) e.insaYili = "İnşa yılı zorunlu.";
    if (!(ctx.fields.kat ?? "").trim()) e.kat = "Kat bilgisi zorunlu.";
    return e;
  },
  // DASK §3 dwelling block (webIntakeSchema.dwelling). grossM2/buildYear are numbers
  // (server z.coerce.number()); structure maps 1:1 onto the YAPI_TARZI enum values.
  buildDwelling: (fields) => ({
    address: (fields.adres ?? "").trim() || undefined,
    uavtCode: digits(fields.uavt ?? "") || undefined,
    grossM2: (fields.m2 ?? "").trim() ? Number(digits(fields.m2 ?? "")) : undefined,
    structure: ((fields.yapiTarzi ?? "").trim() || undefined) as
      | "betonarme"
      | "celik"
      | "yigma"
      | "diger"
      | undefined,
    buildYear: (fields.insaYili ?? "").trim() ? Number(digits(fields.insaYili ?? "")) : undefined,
    floor: (fields.kat ?? "").trim() || undefined,
  }),
  summary: (fields) => ({
    label: `DASK · ${(fields.il ?? "").trim() || "Konutunuz"}`,
    value: "Teklif hazırlanıyor",
  }),
};

export function DaskBasvuru() {
  return <BasvuruFlow config={config} />;
}
